export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "NAME": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
          "PLACEHOLDER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter name"])},
          "ERROR": {
            "LONG": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Name is too long. ", _interpolate(_named("x")), " characters are allowed"])}
          }
        },
        "TYPE": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])}
        },
        "COMPANIES": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Partners"])}
        },
        "STATUS": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
        },
        "EFFECTIVE_DATE": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effective date"])}
        },
        "DEFINITION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Definition"])},
        "VALIDITY": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Validity"])},
        "CUSTOM": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Custom"])}
      }
    }
  })
}
